import { CreateDataSourceMappingResponse, FetchDataSourceChildrenResponse, FetchDataSourceMappingsResponse, FetchDataSourceResponse, SyncDataSourceMappingResponse } from "../../types/dataSource";
import { AUTHENTICATING_DATA_SOURCE, AUTHENTICATING_DATA_SOURCE_FAILED, AUTHENTICATING_DATA_SOURCE_SUCCEEDED, CREATING_DATA_SOURCE_MAPPING_FAILED, CREATING_DATA_SOURCE_MAPPING_REQUEST, CREATING_DATA_SOURCE_MAPPING_SUCCEEDED, CREATING_RSS_DATA_SOURCE, CREATING_RSS_DATA_SOURCE_FAILED, CREATING_RSS_DATA_SOURCE_SUCCEEDED, DELETING_DATA_SOURCE, DELETING_DATA_SOURCE_FAILED, DELETING_DATA_SOURCE_MAPPING_FAILED, DELETING_DATA_SOURCE_MAPPING_REQUEST, DELETING_DATA_SOURCE_MAPPING_SUCCEEDED, DELETING_DATA_SOURCE_SUCCEEDED, FETCHING_DATA_SOURCE_CHILDREN_FAILED, FETCHING_DATA_SOURCE_CHILDREN_REQUEST, FETCHING_DATA_SOURCE_CHILDREN_SUCCEEDED, FETCHING_DATA_SOURCE_MAPPINGS_FAILED, FETCHING_DATA_SOURCE_MAPPINGS_REQUEST, FETCHING_DATA_SOURCE_MAPPINGS_SUCCEEDED, FETCHING_DATA_SOURCES_FAILED, FETCHING_DATA_SOURCES_REQUEST, FETCHING_DATA_SOURCES_SUCCEEDED, INVALIDATE_DATA_SOURCE_DELETION, INVALIDATE_DATA_SOURCE_MIGRATION_STATUS, INVALIDATE_DATA_SOURCE_SYNC, MIGRATING_DATA_SOURCE, MIGRATING_DATA_SOURCE_FAILED, MIGRATING_DATA_SOURCE_SUCCEEDED, SYNCING_DATA_SOURCE, SYNCING_DATA_SOURCE_FAILED, SYNCING_DATA_SOURCE_MAPPING_FAILED, SYNCING_DATA_SOURCE_MAPPING_REQUEST, SYNCING_DATA_SOURCE_MAPPING_SUCCEEDED, SYNCING_DATA_SOURCE_SUCCEEDED, WS_DATASOURCE_MIGRATION_COMPLETION, WS_DATASOURCE_MIGRATION_STATUS, WS_DATASOURCE_SYNC_STATUS } from "../actions/actionTypes";

interface DataSource {
  loading: boolean;
  invalidated: boolean;
  loadingChildren: boolean;
  fetchedChildren: boolean;
  items: any[];
  oauth2: any,
  folder: {
    loading: boolean,
    items: any[],
    invalidated: boolean
  },
  mappings: {
    loading: boolean,
    items: any[]
  },
  mapping: {
    source: any,
    created: boolean,
    creating: boolean,
    error: any
  },
  syncProgress: any[],
  deletion: any[],
  migrationProgress: any[]
}

const initialState: DataSource = {
  loading: false,
  invalidated: true,
  loadingChildren: false,
  fetchedChildren: false,
  items: [],
  oauth2: {},
  folder: {
    loading: false,
    items: [],
    invalidated: true
  },
  mappings: {
    loading: false,
    items: []
  },
  mapping: {
    source: null,
    created: false,
    creating: false,
    error: null
  },
  syncProgress: [],
  deletion: [],
  migrationProgress: []
};

interface DataSourceActions {
  [key: string]: any;
}


export function dataSourceReducer(state: DataSource = initialState, action: DataSourceActions): DataSource {
  switch (action.type) {

    case FETCHING_DATA_SOURCES_REQUEST: {
      return {
        ...state,
        loading: true,
        invalidated: false
      }
    }

    case FETCHING_DATA_SOURCES_SUCCEEDED: {
      const data = action.payload as FetchDataSourceResponse;

      return {
        ...state,
        loading: false,
        items: data.datasources
      }
    }

    case FETCHING_DATA_SOURCES_FAILED: {
      return {
        ...state,
        loading: false,
        items: []
      }
    }

    case FETCHING_DATA_SOURCE_MAPPINGS_REQUEST: {
      return {
        ...state,
        mappings: {
          ...state.mappings,
          loading: true,
          items: []
        }
      }
    }

    case FETCHING_DATA_SOURCE_MAPPINGS_SUCCEEDED: {
      const data = action.payload as FetchDataSourceMappingsResponse;

      return {
        ...state,
        mappings: {
          ...state.mappings,
          loading: false,
          items: data.mappings
        }
      }
    }

    case FETCHING_DATA_SOURCE_MAPPINGS_FAILED: {
      return {
        ...state,
        mappings: {
          ...state.mappings,
          loading: false,
          items: []
        }
      }
    }

    case FETCHING_DATA_SOURCE_CHILDREN_REQUEST: {

      var source = action.payload.account;
      const parent = action.payload.parent;

      var items = state.items.map((item) => {
        if (item.id == source) {
          if(parent){
            return {
              ...item,
              children: {
              ...item.children,
              loading: true,
              items: [...item.children.items],
              [parent]: {
                loading: true,
                items: []
              }
              }
            }
          } else {
            return {
              ...item,
              children: {
                loading: true,
                items: []
              }
            }
          }
        }

        return item;
      });

      return {
        ...state,
        loadingChildren: true,
        items: items
      }
    }

    case FETCHING_DATA_SOURCE_CHILDREN_SUCCEEDED: {

      const data = action.payload as FetchDataSourceChildrenResponse;
      var source = data.account;
      const parent = data.parent;

      const children = data.children
      .filter((item: any) => item.name)
      .sort((d1: any, d2: any) => {
        var nameA = d1.name.toUpperCase(); 
        var nameB = d2.name.toUpperCase()

        if (d1.file && !d2.file) {
          return 1;
        }

        if (!d1.file && d2.file) {
          return -1;
        }


        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });

      var items = state.items.map((item) => {
        if (item.id == source) {
          if(parent){
            return {
              ...item,
              children: {
              ...item.children,
              loading: false,
              items: [...item.children.items],
              [parent]: {
                loading: false,
                items: children
              }
              }
            }
          } else {
            return {
              ...item,
              fetchedChildren: true,
              children: {
                loading: false,
                items: children
              }
            }
          }
        }

        return item;
      });

      return {
        ...state,
        loadingChildren: false,
        fetchedChildren: true,
        items: items
      }
    }

    case FETCHING_DATA_SOURCE_CHILDREN_FAILED: {

      const data = action.payload;
      var source = data.account;
      var error = data.error;

      var items = state.items.map((item) => {
        if (item.id == source) {
          return {
            ...item,
            children: {
              loading: false,
              items: [],
              error: error
            }
          }
        }

        return item;
      });

      return {
        ...state,
        loadingChildren: false,
        items: items
      }
    }

    case CREATING_DATA_SOURCE_MAPPING_REQUEST: {

      const data = action.payload;
      const source = data.source;

      return {
        ...state,
        mapping: {
          ...state.mapping,
          source: source,
          created: false,
          creating: true
        }
      }
    }

    case CREATING_DATA_SOURCE_MAPPING_SUCCEEDED: {
      const data = action.payload as CreateDataSourceMappingResponse;
      const source = data.source;
      const mapping = data.mapping;

      if (!mapping || !mapping.id) {
        return state; 
      }

      let items = [...state.mappings.items, mapping];

      items = items.reduce((x: any, y: any) => {

        if (!y || !y.id) {
          return x; 
        }

        var index = x.findIndex((e: any) => {
          return e.id == y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }

      }, []);

      items = items.filter(item => item);

      items = items.map((item) => {
        return {
          ...item,
          synchronising: false,
          deleting: false
        }
      });

      return {
        ...state,
        mapping: {
          ...state.mapping,
          source: source,
          creating: false,
          created: true
        },
        mappings: {
          ...state.mappings,
          items: items
        }
      }

    }

    case CREATING_DATA_SOURCE_MAPPING_FAILED: {

      const data = action.payload;
      const source = data.source;
      var error = data.error;

      return {
        ...state,
        mapping: {
          ...state.mapping,
          source: source,
          creating: false,
          created: false,
          error: error
        }
      }
    }

    case SYNCING_DATA_SOURCE_MAPPING_REQUEST: {
      const data = action.payload;
      const mappingId = data.id;

      return {
        ...state,
        mappings: {
          ...state.mappings,
          items: state.mappings.items.map((item) => {
            if (item.id == mappingId) {
              return Object.assign({}, item, {
                ...item,
                synchronising: true
              });
            }
            return item;
          })
        }
      }
    }

    case SYNCING_DATA_SOURCE_MAPPING_SUCCEEDED: {
      const data = action.payload as SyncDataSourceMappingResponse;
      const mapping = data.mapping;
    
      if (!mapping || !mapping.id) {
        console.error("Invalid mapping data", mapping);
        return state; 
      }
    
      return {
        ...state,
        mappings: {
          ...state.mappings,
          items: state.mappings.items.map((item) => {
            if (item.id === mapping.id) {
              return {
                ...mapping, 
                synchronising: false
              };
            }
            return item;
          })
        }
      };
    }
    

    case SYNCING_DATA_SOURCE_MAPPING_FAILED: {

      const data = action.payload;
      var mappingId = data.mappingId;
      var error = data.error;

      return {
        ...state,
        mappings: {
          ...state.mappings,
          items: state.mappings.items.map((item) => {
            if (item.id == mappingId) {
              return {
                ...item,
                synchronising: false,
                error: error
              };
            }
            return item;
          })
        }
      }
    }

    case DELETING_DATA_SOURCE_MAPPING_REQUEST: {
      const data = action.payload;
      const mappingId = data.id;

      return {
        ...state,
        mappings: {
          ...state.mappings,
          items: state.mappings.items.map((item) => {
            if (item.id == mappingId) {
              return Object.assign({}, item, {
                ...item,
                deleting: true,
                deleted: false
              });
            }
            return item;
          })
        }
      }
    }

    case DELETING_DATA_SOURCE_MAPPING_SUCCEEDED: {
      const data = action.payload;
      const mappingId = data.mappingId;
  
      return {
          ...state,
          mappings: {
              ...state.mappings,
              items: state.mappings.items.filter((item) => item.id !== mappingId) 
          },
          deletion: {
            ...state.deletion, ...state.mappings.items.find((item) => item.id === mappingId) 
          }
      }
  }
  

    case DELETING_DATA_SOURCE_MAPPING_FAILED: {
      const data = action.payload;
      const mappingId = data.mappingId;
      const error = data.error;

      return {
        ...state,
        mappings: {
          ...state.mappings,
          items: state.mappings.items.map((item) => {
            if (item.id == mappingId) {
              return Object.assign({}, item, {
                ...item,
                deleting: false,
                deleted: false,
                error: error
              });
            }
            return item;
          })
        }
      }
    }


    case WS_DATASOURCE_SYNC_STATUS: {
      const id = action.payload.id;
      let syncProgress = state.syncProgress;
    
      const index = syncProgress.findIndex((item) => item.id === id);
      
      if (index !== -1) {
        const existing = syncProgress[index];
        syncProgress = [
          ...syncProgress.slice(0, index),
          {
            ...existing,
            ...action.payload,
            newAssets: Math.max(action.payload.newAssets, existing.newAssets),
            existingAssets: Math.max(action.payload.existingAssets, existing.existingAssets),
          },
          ...syncProgress.slice(index + 1)
        ];
      } else {
        syncProgress = [...syncProgress, action.payload];
      }
    
      return {
        ...state,
        syncProgress,
        mappings: {
          ...state.mappings,
          items: state.mappings.items.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                status: syncProgress.find((item) => item.id === id)?.completed ? "SYNCED" : "IN_PROGRESS"
              };
            }
            return item;
          })
        }
      };
    }

    case INVALIDATE_DATA_SOURCE_SYNC: {
      return {
        ...state,
        syncProgress: []
      }
    }

    case INVALIDATE_DATA_SOURCE_DELETION: {
      return {
        ...state,
        deletion: []
      }
    }

    case AUTHENTICATING_DATA_SOURCE: {
      const data = action.payload;

      return {
        ...state,
        oauth2: {
          ...state.oauth2,
          [data.sourceType]: {
            authenticating: true
          }
        }
      }
    }

    case AUTHENTICATING_DATA_SOURCE_SUCCEEDED: {
      const data = action.payload;
      let items = state.items;

      items = [...items, data.response];

      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id == y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }

      }, []);

      return {
        ...state,
        oauth2: {
          ...state.oauth2,
          [data.sourceType]: {
            authenticating: false
          }
        },
        items: items
      }
    }

    case AUTHENTICATING_DATA_SOURCE_FAILED: {
      const data = action.payload;

      return {
        ...state,
        oauth2: {
          ...state.oauth2,
          [data.sourceType]: {
            authenticating: false,
            error: error
          }
        }
      }
    }

    case DELETING_DATA_SOURCE: {
      const data = action.payload;

      return {
        ...state,
        items: state.items.map(
          (source, i) => source.id === data.id ? { ...source, deleting: true } : source
        )
      }
    }

    case DELETING_DATA_SOURCE_SUCCEEDED: {
      const data = action.payload;

      return {
        ...state,
        items: state.items.filter(
          (source, i) => { return source.id != data.id }
        )
      }
    }

    case DELETING_DATA_SOURCE_FAILED: {
      const data = action.payload;

      return {
        ...state,
        items: state.items.map(
          (source, i) => source.id === data.id ? { ...source, deleting: false } : source
        )
      }
    }

    case SYNCING_DATA_SOURCE: {
      const data = action.payload;

      return {
        ...state,
        items: state.items.map(
          (source, i) => source.id === data.id ? { ...source, synchronising: true } : source
        )
      }
    }

    case SYNCING_DATA_SOURCE_SUCCEEDED: {
      const data = action.payload;

      return {
        ...state,
        items: state.items.map(
          (source, i) => source.id === data.id ? { ...source, synchronising: false } : source
        )
      }
    }

    case SYNCING_DATA_SOURCE_FAILED: {
      const data = action.payload;

      return {
        ...state,
        items: state.items.map(
          (source, i) => source.id === data.id ? { ...source, synchronising: false } : source
        )
      }
    }

    case MIGRATING_DATA_SOURCE: {
      const data = action.payload;

      return {
        ...state,
        items: state.items.map(
          (source, i) => source.id === data.id ? { ...source, migrating: true, migrated: false } : source
        )
      }
    }

    case MIGRATING_DATA_SOURCE_SUCCEEDED: {
      const data = action.payload.response;

      return {
        ...state,
        items: state.items.map(
          (source, i) => source.id === data.id ? {...data, children: {...source.children}, migrating: false, migrated: true } : source
        )
      }
    }

    case MIGRATING_DATA_SOURCE_FAILED: {
      const data = action.payload;

      return {
        ...state,
        items: state.items.map(
          (source, i) => source.id === data.id ? { ...data, migrating: false, migrated: false } : source
        )
      }
    }

    case INVALIDATE_DATA_SOURCE_MIGRATION_STATUS: {

      const data = action.payload;

      return {
        ...state,
        migrationProgress: state.migrationProgress.filter((item) => {
          return item.id != data.id
        })
      }
    }

    case WS_DATASOURCE_MIGRATION_STATUS:
    case WS_DATASOURCE_MIGRATION_COMPLETION:

      const response = action.payload;
      var id = response.id;

      var migrationProgress = state.migrationProgress;

      var index = migrationProgress.findIndex((item) => {
        return item.id == id;
      });

      if (index != -1) {
        var existing = migrationProgress[index];
        migrationProgress[index] =  {
          ...existing,
          ...response,
          migratedAssets: Math.max(response.migratedAssets, existing.migratedAssets),
          existingAssets: Math.max(response.existingAssets, existing.existingAssets)
        };
      } else {
        migrationProgress = [...migrationProgress, action.payload];
      }

      return {
        ...state,
        migrationProgress: migrationProgress
      }

      case CREATING_RSS_DATA_SOURCE: {
        const data = action.payload;
        
        return {
          ...state,
          oauth2: {
            ...state.oauth2,
            [data.sourceType]: {
              authenticating: true,
              authenticated: false
            }
          }
        }
      }

      case CREATING_RSS_DATA_SOURCE_SUCCEEDED: {
        const data = action.payload;
        let items = state.items;

        items = [...items, data.source];

        items = items.reduce((x, y) => {
          var index = x.findIndex((e) => {
            return e.id == y.id;
          });

          if (index < 0) {
            return [...x, y];
          } else {
            x[index] = y;
            return x;
          }

        }, []);

        return {
          ...state,
          oauth2: {
            ...state.oauth2,
            [data.sourceType]: {
              authenticating: false,
              authenticated: true
            }
          },
          items: items
        }
      }

      case CREATING_RSS_DATA_SOURCE_FAILED: {
        const data = action.payload;

        return {
          ...state,
          oauth2: {
            ...state.oauth2,
            [data.sourceType]: {
              authenticating: false,
              authenticated: false,
              error: data.error
            }
          }
        }
      }
    
    default:
      return state;
  }
}
